import {onFind} from "@elements/init-modules-in-scope";
import {on,findIn,findAllIn} from '@elements/dom-utils';

const selectors = {
    basePackages: '.js-packages',
    selectPackages: '.js-packages__select',
    contentPackages: '.js-packages__content',
};

export function init() {
    onFind(selectors.basePackages, function (baseElement) {
        let select = findIn(selectors.selectPackages, baseElement);
        let content = findAllIn(selectors.contentPackages, baseElement);

        on('change', function() {
            //get attribute data-value
            let selectedOption = select.options[select.selectedIndex];
            let value = parseInt(selectedOption.getAttribute("data-value"));
            let numbers = false;

            if(value > 0) {
                numbers = Array.from(Array(value).keys()).map((i) => i + 1);
            }

            content.forEach((content) => {
                content.setAttribute("hidden", true);
            });

            if (numbers) {
                numbers.forEach((number) => {
                    let additionalInputs = baseElement.querySelector("[data-weight='" + number + "']");
                    additionalInputs.removeAttribute("hidden");
                });
            }
        }, select);
    });
}

